import { useGlobalData } from "../contextApi/globalContextData";
import Services from "./homepage/Services";
import WhyUs from "../utility/serviceTemplateutility/WhyUs";
import OurTeam from "./homepage/OurTeam";
import Testimonials from "./homepage/Testimonials";
import OurTeamHome from "./homepage/OurTeamHome";
import InstagramFeed from "../utility/serviceTemplateutility/InstagramFeed";

const AboutUs = () => {
  const { sectionsData, loading, error } = useGlobalData();
  return (
    <div className="container py-5">
      <div className="text-center mb-4">
        <h2
          style={{
            color: "#c69933",
          }}
        >
          Welcome to Elite Body Home Polyclinic
        </h2>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-10">
          <p className="lead text-secondary">
            At Elite Body Home Polyclinic, we are committed to enhancing your
            beauty, health, and well-being through state-of-the-art aesthetic,
            weight management, physiotherapy, and dental treatments. Located in
            the heart of Dubai, our clinic offers a premium experience with
            personalized care tailored to your unique needs.
          </p>
        </div>
      </div>
      {sectionsData["Services"] && <Services data={sectionsData["Services"]} />}

      <WhyUs language="en" />
      <div className="text-center" style={{ marginTop: "3rem" }}>
        <h3
          className="fw-bold fade-in"
          style={{ color: "#c69933", fontSize: "3rem" }}
        >
          Meet Our Specialists
        </h3>
      </div>
      {sectionsData["Professional"] && (
        <OurTeamHome data={sectionsData["Professional"]} />
      )}

      {sectionsData["Success Stories"] && (
        <Testimonials data={sectionsData["Success Stories"]} />
      )}

      <InstagramFeed />
    </div>
  );
};

export default AboutUs;
